import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { PostInterface, setEditId, setEditError, selectPostById } from "src/store/community/postsSlice";
import { updatePost, fetchPost } from "src/actions/community/postsActions";
import { objToFormData } from "src/helpers/FormHelper";

import Form from './_partials/_Form';
import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";
import moment from "moment";

const Edit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id: any = useAppSelector(state => state.community.posts.editId);
  const error = useAppSelector(state => state.community.posts.editError);
  const post = useAppSelector(state => id ? selectPostById(state, id) : undefined);
  const params: any = { ...post };
  params.moment_date = moment(post?.published_at);

  useEffect(() => {
    if (id) {
      dispatch(fetchPost(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };
    delete data.moment_date;

    data.published_at = rawData.moment_date.toString();

    handleSave(data).catch(console.error);
  }

  async function handleSave(data: PostInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updatePost({ id, data: formData }));

    if (updatePost.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-post'>
        <h6 className="v-content-label">Edit Post</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={params} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
